import { createContext } from "react";

export const STORAGE_KEY_STORED_AUDIENCE = "audience/storedAudience";

/**
 * An "audience" corresponds to a furniture document
 * For apps with more than one audience, there will be more than one furniture document
 */
export enum Audience {
    Default = "DEFAULT",
    FriendsAndFamily = "FRIENDS_AND_FAMILY",
    Teen = "TEEN",
}

export enum Onboarding {
    Default = "DEFAULT",
    Teen = "TEEN",
}

const defaultAudienceContext = {
    audience: Audience.Default,
    setAudience: (x: Audience) => null,
};

export const FurnitureContext = createContext<any | null>(null);

export const AudienceContext = createContext(defaultAudienceContext);
